import React, { useState, useEffect } from "react";
import Layout from "../Common/Layout";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OutboundGateEntry = () => {
    const RequiredStar = () => (
    <span style={{ color: "red", marginLeft: "4px" }}>*</span>
  );
  const navigate = useNavigate();

  const deliveryorder = JSON.parse(sessionStorage.getItem("deliveryorder"));


    const sessionDate = deliveryorder.date || "";


  const [formData, setFormData] = useState({
    warehouse: deliveryorder.warehouse, // ✅ ADD THIS
    cargoType: deliveryorder.cargo_type || "", // ✅ ADD THIS

    truck_nos: [""],
    entry_date: sessionDate,
    entry_time: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const now = new Date();

    const today = now.toISOString().split("T")[0]; // YYYY-MM-DD
    const currentTime = now.toTimeString().slice(0, 5); // HH:mm

    setFormData((prev) => ({
      ...prev,
      entry_time: currentTime,
    }));
  }, []);

  /* ===================== TRUCK HANDLERS ===================== */

  const handleTruckChange = (index, value) => {
    setFormData((prev) => {
      const updated = [...prev.truck_nos];
      updated[index] = value.toUpperCase();

      return {
        ...prev,
        truck_nos: updated,
      };
    });
  };

  const addTruck = () => {
    setFormData((prev) => ({
      ...prev,
      truck_nos: [...prev.truck_nos, ""],
    }));
  };

  const removeTruck = (index) => {
    const updatedTrucks = formData.truck_nos.filter((_, i) => i !== index);

    setFormData({
      ...formData,
      truck_nos: updatedTrucks.length ? updatedTrucks : [""],
    });
  };

  /* ===================== FORM SUBMIT ===================== */

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = sessionStorage.getItem("token");
    if (!token) {
      toast.error("Unauthorized! Please login again.");
      return;
    }

    setLoading(true);

    try {
      // 💾 Store first truck number if needed later
      sessionStorage.setItem("truckNo", formData.truck_nos[0]);

      const response = await fetch("https://irc.zentelex.com/api/gateentry", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          cddNo: deliveryorder.cddNo,
          warehouse: formData.warehouse, // ✅ ADD THIS
          truck_nos: formData.truck_nos,
          entry_date: formData.entry_date,
          entry_time: formData.entry_time,
          entry_type: "OUTBOUND",
        }),
      });

      const data = await response.json();

      console.log(data.data.gate_entry_no);

      sessionStorage.setItem("gatepass", data?.data?.gate_entry_no);

      if (data.success) {
        toast.success("✅ Gate entry created successfully!", {
          autoClose: 2000,
        });

        setTimeout(() => {
          navigate("/outbound-kata-slip-data");
        }, 2000);
      } else {
        toast.error(data.message || "❌ Failed to create gate entry");
      }
    } catch (error) {
      console.error("Gate Entry Error:", error);
      toast.error("❌ Server error!");
    } finally {
      setLoading(false);
    }
  };

  /* ===================== UI ===================== */

  return (
    <Layout>
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row justify-content-center mt-4">
              <div className="col-xxl-6 col-lg-8 col-md-10">
                <div className="card shadow-sm border-0 rounded-4">
                  <div
                    className="card-body p-4 rounded-4"
                    style={{ backgroundColor: "#3075A6" }}
                  >
                    <h4 className="text-center fw-semibold text-white mb-4">
                      Outbound Gateway Entry
                    </h4>

                    <form onSubmit={handleSubmit}>
                      {/* Truck Numbers */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-white">
                          Truck Numbers<RequiredStar />
                        </label>

                        {formData.truck_nos.map((truck, index) => (
                          <div key={index} className="d-flex gap-2 mb-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="WB78 AB 9874"
                              value={truck}
                              onChange={(e) =>
                                handleTruckChange(index, e.target.value)
                              }
                              required
                            />

                            {formData.truck_nos.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => removeTruck(index)}
                              >
                                ✕
                              </button>
                            )}
                          </div>
                        ))}

                        <button
                          type="button"
                          className="btn btn-light btn-sm mt-2"
                          onClick={addTruck}
                        >
                          + Add Truck
                        </button>
                      </div>

                      {/* Entry Date */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold text-white">
                          Entry Date<RequiredStar />
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={formData.entry_date}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              entry_date: e.target.value,
                            })
                          }
                          required
                          readOnly
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label fw-semibold text-white">
                          Cargo Type<RequiredStar />
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.cargoType}
                          readOnly
                        />
                      </div>

                      {/* Entry Time */}
                      <div className="mb-4">
                        <label className="form-label fw-semibold text-white">
                          Entry Time<RequiredStar />
                        </label>
                        <input
                          type="time"
                          className="form-control"
                          value={formData.entry_time}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              entry_time: e.target.value,
                            })
                          }
                          required
                        />
                      </div>

                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn px-5 py-2 fw-semibold"
                          disabled={loading}
                          style={{
                            backgroundColor: "#EC662C",
                            color: "white",
                          }}
                        >
                          {loading ? "Submitting..." : "Submit"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={3000} />
    </Layout>
  );
};

export default OutboundGateEntry;
